// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/show_tooltip.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../img/show_jotpa_tooltip.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../img/checkmark.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../img/remove_line_enabled.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../img/remove_line_disabled.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup-box-shadow {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.4);
}
.modal {
  position: fixed;
  top: 30%;
  left: 30%;
  right: 40%;
  bottom: 30%;
  background-color: #f0f0f0;
  height: 350px;
  width: 600px;
  padding: 30px 5px 15px 0px;
  border-radius: 8px;
  opacity: 1;
}
.modal-label {
  padding-right: 0px;
}
.modal-label > input {
  margin: 0 10px 0 10px;
  padding: 8px;
}
.modal:focus {
  outline: none;
}
.modal > div {
  text-align: center;
  vertical-align: middle;
  margin-top: 60px;
  opacity: none;
}
.get-business-id:disabled {
  background-color: #807a78;
}
.overlay {
  z-index: 1000;
  left: 0;
  top: 0;
  position: fixed;
  height: 100%;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.5);
}
input[type="text"].error {
  border: 2px solid #c9302c;
}
#not-found-business-id,
#other-error-business-ids > span {
  color: #c9302c;
  font-weight: bold;
}
.soresu-tooltip {
  position: relative;
}
.soresu-tooltip.soresu-help-icon,
.soresu-tooltip.jotpa-help-icon {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-top: 1px;
  margin-left: 11px;
  background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat left top !important;
}
.soresu-tooltip.jotpa-help-icon {
  background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat left top !important;
}
.soresu-tooltip > span {
  position: absolute;
  width: 600px;
  left: -223px;
  margin-left: -76px;
  margin-bottom: -4px;
  color: #4a4a4a;
  background: #fff;
  border: 1px solid #d9d9d9;
  font-size: 14px;
  padding: 5px 15px;
  visibility: hidden;
  white-space: pre-line;
}
.soresu-tooltip > span:before,
.soresu-tooltip > span:after {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
  border-color: transparent;
}
.soresu-tooltip > span:before {
  left: 295px;
  border-width: 11px;
}
.soresu-tooltip > span:after {
  left: 296px;
  border-width: 10px;
}
:hover.soresu-tooltip > span {
  visibility: visible;
  opacity: 0.95;
  z-index: 99;
}
.soresu-tooltip-up > span:before,
.soresu-tooltip-up > span:after {
  border-bottom: 0;
}
.soresu-tooltip-up > span:before {
  bottom: -11px;
  border-top-color: #d9d9d9;
}
.soresu-tooltip-up > span:after {
  bottom: -10px;
  border-top-color: #fff;
}
:hover.soresu-tooltip-up > span {
  bottom: 32px;
}
.soresu-tooltip-down > span:before,
.soresu-tooltip-down > span:after {
  border-top: 0;
}
.soresu-tooltip-down > span:before {
  top: -11px;
  border-bottom-color: #d9d9d9;
}
.soresu-tooltip-down > span:after {
  top: -10px;
  border-bottom-color: #fff;
}
:hover.soresu-tooltip-down > span {
  top: 42px;
}
.soresu-tooltip-left > span:before,
.soresu-tooltip-left > span:after {
  border-left: 0;
}
.soresu-tooltip-left > span:before {
  top: 8px;
  left: -11px;
  border-right-color: #d9d9d9;
}
.soresu-tooltip-left > span:after {
  top: 9px;
  left: -10px;
  border-right-color: #fff;
}
:hover.soresu-tooltip-left > span {
  top: -10px;
  left: 106px;
}
.soresu-tooltip-right > span:before,
.soresu-tooltip-right > span:after {
  border-right: 0;
}
.soresu-tooltip-right > span:before {
  left: 630px;
  border-left-color: #d9d9d9;
}
.soresu-tooltip-right > span:after {
  top: 6px;
  left: 630px;
  border-left-color: #fff;
}
:hover.soresu-tooltip-right > span {
  top: -10px;
  left: -568px;
}
.soresu-tooltip-valmistelijan-huomiot > span:before,
.soresu-tooltip-valmistelijan-huomiot > span:after {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
  border-color: transparent;
}
.soresu-tooltip-valmistelijan-huomiot > span:before {
  left: 105px;
  border-width: 11px;
}
.soresu-tooltip-valmistelijan-huomiot > span:after {
  left: 106px;
  border-width: 10px;
}
.soresu-tooltip-valmistelijan-huomiot > span:before,
.soresu-tooltip-valmistelijan-huomiot > span:after {
  border-top: 0;
}
.soresu-tooltip-valmistelijan-huomiot > span:before {
  top: -11px;
  border-bottom-color: #d9d9d9;
}
.soresu-tooltip-valmistelijan-huomiot > span:after {
  top: -10px;
  border-bottom-color: #fff;
}
:hover.soresu-tooltip-valmistelijan-huomiot > span {
  top: 42px;
  left: -30px;
}
.soresu-tooltip-salli-nakyvyys > span:before,
.soresu-tooltip-salli-nakyvyys > span:after {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
  border-color: transparent;
}
.soresu-tooltip-salli-nakyvyys > span:before {
  left: 250px;
  border-width: 11px;
}
.soresu-tooltip-salli-nakyvyys > span:after {
  left: 251px;
  border-width: 10px;
}
.soresu-tooltip-salli-nakyvyys > span:before,
.soresu-tooltip-salli-nakyvyys > span:after {
  border-top: 0;
}
.soresu-tooltip-salli-nakyvyys > span:before {
  top: -11px;
  border-bottom-color: #d9d9d9;
}
.soresu-tooltip-salli-nakyvyys > span:after {
  top: -10px;
  border-bottom-color: #fff;
}
:hover.soresu-tooltip-salli-nakyvyys > span {
  top: 42px;
  left: -180px;
}
.soresu-tooltip-arviointi > span:before,
.soresu-tooltip-arviointi > span:after {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
  border-color: transparent;
}
.soresu-tooltip-arviointi > span:before {
  left: 105px;
  border-width: 11px;
}
.soresu-tooltip-arviointi > span:after {
  left: 106px;
  border-width: 10px;
}
.soresu-tooltip-arviointi > span:before,
.soresu-tooltip-arviointi > span:after {
  border-bottom: 0;
}
.soresu-tooltip-arviointi > span:before {
  bottom: -11px;
  border-top-color: #d9d9d9;
}
.soresu-tooltip-arviointi > span:after {
  bottom: -10px;
  border-top-color: #fff;
}
:hover.soresu-tooltip-arviointi > span {
  bottom: 32px;
  left: -30px;
}
.soresu-tooltip-arviointi-slim > span {
  max-width: 500px;
  bottom: 32px;
  left: -30px;
}
.soresu-tooltip-arviointi-slim > span:before,
.soresu-tooltip-arviointi-slim > span:after {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
  border-color: transparent;
}
.soresu-tooltip-arviointi-slim > span:before {
  left: 105px;
  border-width: 11px;
}
.soresu-tooltip-arviointi-slim > span:after {
  left: 106px;
  border-width: 10px;
}
.soresu-tooltip-arviointi-slim > span:before,
.soresu-tooltip-arviointi-slim > span:after {
  border-bottom: 0;
}
.soresu-tooltip-arviointi-slim > span:before {
  bottom: -11px;
  border-top-color: #d9d9d9;
}
.soresu-tooltip-arviointi-slim > span:after {
  bottom: -10px;
  border-top-color: #fff;
}
:hover.soresu-tooltip-arviointi-slim > span {
  max-width: 500px;
  bottom: 32px;
  left: -30px;
}
.jotpa-customizations {
  font-family: 'Montserrat', sans-serif;
}
.jotpa-customizations .soresu-radio input[type=radio]:checked + label,
.jotpa-customizations .soresu-checkbox input[type=radio]:checked + label,
.jotpa-customizations .soresu-radio input[type=checkbox]:checked + label,
.jotpa-customizations .soresu-checkbox input[type=checkbox]:checked + label {
  border-color: #009b62;
}
.jotpa-customizations #topbar #submit:not([disabled]) {
  background-color: #009b62;
}
.jotpa-customizations button.soresu-text-button,
.jotpa-customizations input.soresu-text-button {
  background-color: #009b62;
}
.jotpa-customizations .soresu-file-upload .soresu-upload-button {
  background-color: #009b62;
}
.jotpa-customizations .soresu-tooltip.soresu-help-icon {
  background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat left top !important;
}
body {
  font-family: 'Open Sans', sans-serif;
  background-color: #fafafa;
  color: #1a1919;
  font-size: 16px;
}
@media print {
  body {
    background-color: white;
    color: black;
  }
}
a {
  color: #159ecb;
  cursor: pointer;
  text-decoration: none;
}
ul {
  margin: 10px 0 0 -40px;
  list-style: none;
}
ul li {
  display: table-row;
}
ul li:before {
  color: #73ba21;
  content: "•";
  font-size: 14px;
  padding-right: 10px;
  display: table-cell;
}
.popup {
  position: fixed;
  max-height: 250px;
  z-index: 101;
  overflow: auto;
  margin-right: 20px;
  background-color: #ffffff;
  padding: 10px;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.14), 0 4px 8px rgba(0, 0, 0, 0.28);
}
#container {
  max-width: 1300px;
  margin-top: 200px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 20px 20px 20px;
}
#container h1 {
  font-weight: 300;
  font-size: 24px;
  margin: 0;
}
#container h2,
#container h3 {
  color: #807a78;
  font-weight: 300;
  font-size: 18px;
}
@media print {
  #container h2,
  #container h3 {
    color: black;
  }
}
#container h2 {
  width: 250px;
}
#container h2 > span {
  text-transform: uppercase;
}
@media print {
  #container {
    margin: 0;
  }
}
.soresu-form fieldset {
  border: 0;
  margin: 0;
  padding: 0;
}
.soresu-form label,
.soresu-form legend {
  color: #4a4a4a;
  margin: 0 0 8px 0;
}
.soresu-form label.disabled,
.soresu-form legend.disabled {
  color: #807a78;
}
.soresu-form label :after,
.soresu-form legend :after {
  content: " ";
}
.soresu-form p.soresu-info-element {
  color: #4a4a4a;
  font-size: 15px;
}
.soresu-form .required:after {
  content: "\\00a0*";
}
section.soresu-theme {
  margin: 25px 0 0 0;
  padding-top: 25px;
  border-top: 1px solid #d9d9d9;
}
section.soresu-theme h2 {
  float: left;
}
section.soresu-theme label {
  display: block;
}
section.soresu-theme > div {
  margin: 0 0 0 250px;
}
section.soresu-theme > div > div,
section.soresu-theme > div > fieldset,
section.soresu-theme > div > p.soresu-info-element {
  margin: 15px 0 20px 0;
}
@media print {
  section.soresu-theme {
    border-top: 0;
  }
}
.soresu-fieldset,
.soresu-growing-fieldset {
  max-width: 811px;
}
.soresu-fieldset > div,
.soresu-growing-fieldset > div {
  display: inline-block;
}
.soresu-growing-fieldset div.extra-large {
  display: block;
}
.soresu-growing-fieldset ol {
  list-style-type: none;
  counter-reset: item;
}
.soresu-growing-fieldset ol li.soresu-growing-fieldset-child {
  margin: 20px 0 0 -58px;
}
.soresu-growing-fieldset ol li.soresu-growing-fieldset-child.disabled {
  color: #807a78;
}
.soresu-growing-fieldset ol li:before {
  content: counter(item) "  ";
  counter-increment: item;
  float: left;
  width: 1em;
  font-size: 18px;
  margin-top: 15px;
}
.soresu-growing-fieldset.show-only-first-label ol li:first-child:before {
  margin-top: 45px;
}
.soresu-text-field input[type=text],
.soresu-email-field input[type=text],
.soresu-text-field input[type=email],
.soresu-email-field input[type=email],
.soresu-text-field textarea,
.soresu-email-field textarea {
  border: 1px solid #c1c1c1;
  padding: 8px;
  background-color: #fff;
}
.soresu-text-field input[type=text].error,
.soresu-email-field input[type=text].error,
.soresu-text-field input[type=email].error,
.soresu-email-field input[type=email].error,
.soresu-text-field textarea.error,
.soresu-email-field textarea.error {
  border: 1px solid #c9302c;
}
.soresu-text-field textarea[disabled],
.soresu-email-field textarea[disabled],
.soresu-text-field input[disabled],
.soresu-email-field input[disabled] {
  cursor: default;
  background-color: #fafafa;
  border: 1px solid #d9d9d9;
}
.soresu-text-field input:focus,
.soresu-email-field input:focus,
.soresu-text-field select:focus,
.soresu-email-field select:focus,
.soresu-text-field textarea:focus,
.soresu-email-field textarea:focus,
.soresu-text-field button:focus,
.soresu-email-field button:focus {
  box-shadow: 0 0 5px #61bae9;
  outline: 1px solid #159ecb;
}
.soresu-text-field input,
.soresu-email-field input,
.soresu-text-field select,
.soresu-email-field select,
.soresu-text-field textarea,
.soresu-email-field textarea,
.soresu-text-field button,
.soresu-email-field button {
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  outline: none;
}
.soresu-text-field input:focus.error,
.soresu-email-field input:focus.error,
.soresu-text-field select:focus.error,
.soresu-email-field select:focus.error,
.soresu-text-field textarea:focus.error,
.soresu-email-field textarea:focus.error {
  box-shadow: 0 0 5px #61bae9;
  outline: 1px solid #c9302c;
}
.soresu-text-field input[type=text],
.soresu-email-field input[type=text],
.soresu-text-field input[type=email],
.soresu-email-field input[type=email] {
  margin: 5px 10px 0 0;
  font-size: 18px;
}
.soresu-text-field input[type=text].extra-extra-small,
.soresu-email-field input[type=text].extra-extra-small,
.soresu-text-field input[type=email].extra-extra-small,
.soresu-email-field input[type=email].extra-extra-small {
  width: 82px;
}
.soresu-text-field input[type=text].extra-small,
.soresu-email-field input[type=text].extra-small,
.soresu-text-field input[type=email].extra-small,
.soresu-email-field input[type=email].extra-small {
  width: 182px;
}
.soresu-text-field input[type=text].small,
.soresu-email-field input[type=text].small,
.soresu-text-field input[type=email].small,
.soresu-email-field input[type=email].small {
  width: 249px;
}
.soresu-text-field input[type=text].medium,
.soresu-email-field input[type=text].medium,
.soresu-text-field input[type=email].medium,
.soresu-email-field input[type=email].medium {
  width: 382px;
}
.soresu-text-field input[type=text].large,
.soresu-email-field input[type=text].large,
.soresu-text-field input[type=email].large,
.soresu-email-field input[type=email].large {
  width: 506px;
}
.soresu-text-field input[type=text].extra-large,
.soresu-email-field input[type=text].extra-large,
.soresu-text-field input[type=email].extra-large,
.soresu-email-field input[type=email].extra-large {
  width: 782px;
}
.soresu-text-field label.extra-extra-small,
.soresu-email-field label.extra-extra-small {
  width: 92px;
}
.soresu-text-field label.extra-small,
.soresu-email-field label.extra-small {
  width: 192px;
}
.soresu-text-field label.small,
.soresu-email-field label.small {
  width: 259px;
}
.soresu-text-field label.medium,
.soresu-email-field label.medium {
  width: 392px;
}
.soresu-text-field label.large,
.soresu-email-field label.large {
  width: 516px;
}
.soresu-text-field label.extra-large,
.soresu-email-field label.extra-large {
  width: 792px;
}
.soresu-money-field input[type=text],
.soresu-money-field input[type=email],
.soresu-money-field textarea {
  border: 1px solid #c1c1c1;
  padding: 8px;
  background-color: #fff;
}
.soresu-money-field input[type=text].error,
.soresu-money-field input[type=email].error,
.soresu-money-field textarea.error {
  border: 1px solid #c9302c;
}
.soresu-money-field textarea[disabled],
.soresu-money-field input[disabled] {
  cursor: default;
  background-color: #fafafa;
  border: 1px solid #d9d9d9;
}
.soresu-money-field input:focus,
.soresu-money-field select:focus,
.soresu-money-field textarea:focus,
.soresu-money-field button:focus {
  box-shadow: 0 0 5px #61bae9;
  outline: 1px solid #159ecb;
}
.soresu-money-field input,
.soresu-money-field select,
.soresu-money-field textarea,
.soresu-money-field button {
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  outline: none;
}
.soresu-money-field input:focus.error,
.soresu-money-field select:focus.error,
.soresu-money-field textarea:focus.error {
  box-shadow: 0 0 5px #61bae9;
  outline: 1px solid #c9302c;
}
.soresu-money-field input[type=text],
.soresu-money-field input[type=email] {
  margin: 5px 10px 0 0;
  font-size: 18px;
}
.soresu-money-field input[type=text].extra-extra-small,
.soresu-money-field input[type=email].extra-extra-small {
  width: 82px;
}
.soresu-money-field input[type=text].extra-small,
.soresu-money-field input[type=email].extra-small {
  width: 182px;
}
.soresu-money-field input[type=text].small,
.soresu-money-field input[type=email].small {
  width: 249px;
}
.soresu-money-field input[type=text].medium,
.soresu-money-field input[type=email].medium {
  width: 382px;
}
.soresu-money-field input[type=text].large,
.soresu-money-field input[type=email].large {
  width: 506px;
}
.soresu-money-field input[type=text].extra-large,
.soresu-money-field input[type=email].extra-large {
  width: 782px;
}
.soresu-money-field label.extra-extra-small {
  width: 92px;
}
.soresu-money-field label.extra-small {
  width: 192px;
}
.soresu-money-field label.small {
  width: 259px;
}
.soresu-money-field label.medium {
  width: 392px;
}
.soresu-money-field label.large {
  width: 516px;
}
.soresu-money-field label.extra-large {
  width: 792px;
}
.soresu-money-field input {
  text-align: right;
}
.soresu-finnish-business-id-field input[type=text],
.soresu-finnish-business-id-field input[type=email],
.soresu-finnish-business-id-field textarea {
  border: 1px solid #c1c1c1;
  padding: 8px;
  background-color: #fff;
}
.soresu-finnish-business-id-field input[type=text].error,
.soresu-finnish-business-id-field input[type=email].error,
.soresu-finnish-business-id-field textarea.error {
  border: 1px solid #c9302c;
}
.soresu-finnish-business-id-field textarea[disabled],
.soresu-finnish-business-id-field input[disabled] {
  cursor: default;
  background-color: #fafafa;
  border: 1px solid #d9d9d9;
}
.soresu-finnish-business-id-field input:focus,
.soresu-finnish-business-id-field select:focus,
.soresu-finnish-business-id-field textarea:focus,
.soresu-finnish-business-id-field button:focus {
  box-shadow: 0 0 5px #61bae9;
  outline: 1px solid #159ecb;
}
.soresu-finnish-business-id-field input,
.soresu-finnish-business-id-field select,
.soresu-finnish-business-id-field textarea,
.soresu-finnish-business-id-field button {
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  outline: none;
}
.soresu-finnish-business-id-field input:focus.error,
.soresu-finnish-business-id-field select:focus.error,
.soresu-finnish-business-id-field textarea:focus.error {
  box-shadow: 0 0 5px #61bae9;
  outline: 1px solid #c9302c;
}
.soresu-finnish-business-id-field input[type=text],
.soresu-finnish-business-id-field input[type=email] {
  margin: 5px 10px 0 0;
  font-size: 18px;
}
.soresu-finnish-business-id-field input[type=text].extra-extra-small,
.soresu-finnish-business-id-field input[type=email].extra-extra-small {
  width: 82px;
}
.soresu-finnish-business-id-field input[type=text].extra-small,
.soresu-finnish-business-id-field input[type=email].extra-small {
  width: 182px;
}
.soresu-finnish-business-id-field input[type=text].small,
.soresu-finnish-business-id-field input[type=email].small {
  width: 249px;
}
.soresu-finnish-business-id-field input[type=text].medium,
.soresu-finnish-business-id-field input[type=email].medium {
  width: 382px;
}
.soresu-finnish-business-id-field input[type=text].large,
.soresu-finnish-business-id-field input[type=email].large {
  width: 506px;
}
.soresu-finnish-business-id-field input[type=text].extra-large,
.soresu-finnish-business-id-field input[type=email].extra-large {
  width: 782px;
}
.soresu-finnish-business-id-field label.extra-extra-small {
  width: 92px;
}
.soresu-finnish-business-id-field label.extra-small {
  width: 192px;
}
.soresu-finnish-business-id-field label.small {
  width: 259px;
}
.soresu-finnish-business-id-field label.medium {
  width: 392px;
}
.soresu-finnish-business-id-field label.large {
  width: 516px;
}
.soresu-finnish-business-id-field label.extra-large {
  width: 792px;
}
.soresu-text-area input[type=text],
.soresu-text-area input[type=email],
.soresu-text-area textarea {
  border: 1px solid #c1c1c1;
  padding: 8px;
  background-color: #fff;
}
.soresu-text-area input[type=text].error,
.soresu-text-area input[type=email].error,
.soresu-text-area textarea.error {
  border: 1px solid #c9302c;
}
.soresu-text-area textarea[disabled],
.soresu-text-area input[disabled] {
  cursor: default;
  background-color: #fafafa;
  border: 1px solid #d9d9d9;
}
.soresu-text-area input:focus,
.soresu-text-area select:focus,
.soresu-text-area textarea:focus,
.soresu-text-area button:focus {
  box-shadow: 0 0 5px #61bae9;
  outline: 1px solid #159ecb;
}
.soresu-text-area input,
.soresu-text-area select,
.soresu-text-area textarea,
.soresu-text-area button {
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  outline: none;
}
.soresu-text-area input:focus.error,
.soresu-text-area select:focus.error,
.soresu-text-area textarea:focus.error {
  box-shadow: 0 0 5px #61bae9;
  outline: 1px solid #c9302c;
}
.soresu-text-area label {
  max-width: 800px;
}
.soresu-text-area textarea {
  width: 782px;
  height: 12em;
  font-size: 16px;
}
.soresu-text-area textarea.extra-extra-small {
  height: 1em;
}
.soresu-text-area textarea.extra-small {
  height: 3em;
}
.soresu-text-area textarea.small {
  height: 6em;
}
.soresu-text-area textarea.medium {
  height: 12em;
}
.soresu-text-area textarea.large {
  height: 18em;
}
.soresu-text-area textarea.extra-large {
  height: 24em;
}
.soresu-text-area .length-left {
  color: #999290;
  font-size: 12px;
  width: 790px;
  text-align: right;
}
@media print {
  .soresu-text-area {
    width: 100%;
  }
}
.soresu-text-button input:focus,
.soresu-text-button select:focus,
.soresu-text-button textarea:focus,
.soresu-text-button button:focus {
  box-shadow: 0 0 5px #61bae9;
  outline: 1px solid #159ecb;
}
.soresu-text-button input,
.soresu-text-button select,
.soresu-text-button textarea,
.soresu-text-button button {
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  outline: none;
}
.soresu-radio input[type=radio],
.soresu-checkbox input[type=radio],
.soresu-radio input[type=checkbox],
.soresu-checkbox input[type=checkbox] {
  display: none;
}
.soresu-radio input[type=radio] + label,
.soresu-checkbox input[type=radio] + label,
.soresu-radio input[type=checkbox] + label,
.soresu-checkbox input[type=checkbox] + label {
  display: inline-block;
  color: #999290;
  margin: 4px 3px;
  padding: 12px 30px;
  background-color: #fff;
  border: solid 1px #c1c1c1;
  cursor: pointer;
}
.soresu-radio input[type=radio] + label.error,
.soresu-checkbox input[type=radio] + label.error,
.soresu-radio input[type=checkbox] + label.error,
.soresu-checkbox input[type=checkbox] + label.error {
  border: solid 1px #c9302c;
}
.soresu-radio input[type=checkbox] + label,
.soresu-checkbox input[type=checkbox] + label {
  width: 732px;
}
.soresu-radio input[type=radio]:checked + label,
.soresu-checkbox input[type=radio]:checked + label,
.soresu-radio input[type=checkbox]:checked + label,
.soresu-checkbox input[type=checkbox]:checked + label {
  color: #000;
  background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat 10px 19px;
  margin: 1px 1px;
  border: solid 4px #73ba21;
}
.soresu-radio input[disabled] + label,
.soresu-checkbox input[disabled] + label {
  color: #d9d9d9;
  border-color: #d9d9d9;
  background-color: #fafafa;
  cursor: default;
}
.soresu-radio input[disabled]:checked + label,
.soresu-checkbox input[disabled]:checked + label {
  color: #999290;
  border: solid 4px #d9d9d9;
  background-color: #fafafa;
}
.soresu-table {
  border-collapse: separate;
  border-spacing: 20px;
  border: 1px solid transparent;
}
.soresu-table div {
  display: block;
}
.soresu-table th.required::after {
  font-weight: normal;
  font-size: 80%;
}
.soresu-table--preview {
  border-collapse: collapse;
  border-spacing: 0;
}
.soresu-table--error {
  border: 1px solid #c9302c;
}
.soresu-table--disabled .soresu-table__caption,
.soresu-table--disabled .soresu-table__column-title-cell,
.soresu-table--disabled .soresu-table__row-title-cell,
.soresu-table--disabled .soresu-table__value-cell,
.soresu-table--disabled .soresu-table__sum-cell {
  color: #807a78;
}
.soresu-table--disabled .soresu-table__value-cell-input {
  background-color: #fafafa;
  border-color: #d9d9d9;
}
.soresu-table__caption {
  color: #4a4a4a;
  text-align: left;
}
.soresu-table__column-title-cell {
  color: #4a4a4a;
  text-align: left;
}
.soresu-table__column-title-cell--number {
  text-align: right;
}
.soresu-table__column-title-cell--preview {
  padding: 4px 10px;
}
.soresu-table__row-title-cell {
  color: #4a4a4a;
  text-align: right;
}
.soresu-table__row-title-cell--preview {
  padding: 4px 10px;
}
.soresu-table__value-cell--number {
  text-align: right;
}
.soresu-table__value-cell--number .soresu-table__value-cell-input {
  text-align: right;
}
.soresu-table__value-cell--placeholder .soresu-table__value-cell-input {
  border-color: #e3e3e3;
}
.soresu-table__value-cell--preview {
  padding: 4px 10px;
  border-bottom: 1px solid #c1c1c1;
}
.soresu-table__value-cell-input {
  text-align: left;
  padding: 5px 9px;
  border: 1px solid #c1c1c1;
}
.soresu-table__value-cell-input--error {
  border: 1px solid #c9302c;
}
.soresu-table__sum-cell {
  color: #4a4a4a;
  padding: 4px 10px;
}
.soresu-table__sum-cell--number {
  border-bottom: 1px solid #c1c1c1;
  text-align: right;
}
.soresu-table__sum-cell--preview {
  border-bottom: 1px solid #c1c1c1;
}
.soresu-table__cell-positioner {
  width: 100%;
  position: relative;
}
.soresu-table__remove-row-button {
  position: absolute;
  right: -30px;
  top: 8px;
}
div.soresu-attachment-input-field button.soresu-remove {
  position: relative;
  top: 4px;
  left: 6px;
}
div.soresu-attachment-input-field div.soresu-attachment-display {
  display: inline-block;
  margin: 0;
}
.soresu-file-upload {
  margin-top: 10px;
  margin-bottom: 4px;
}
.soresu-file-upload.error span.required {
  color: #c9302c;
}
.soresu-file-upload .soresu-upload-button {
  color: #fff;
  background-color: #73ba21;
  border-width: 0;
  margin: 4px 0 4px 0;
  padding: 4px 24px;
  font-size: 16px;
  cursor: pointer;
}
.soresu-file-upload.disabled {
  color: #807a78;
}
.soresu-file-upload.disabled .soresu-upload-button {
  background-color: #d9d9d9;
  border: 1px solid #d9d9d9;
  cursor: default;
}
.soresu-file-upload.disabled div {
  border-color: #999290;
  cursor: default;
}
button.soresu-remove {
  background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat left top;
  border-width: 0;
  width: 20px;
  height: 22px;
}
button[disabled].soresu-remove {
  background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat left top;
}
button.soresu-text-button,
input.soresu-text-button {
  color: #fff;
  background-color: #73ba21;
  border-width: 0;
  margin: 4px 20px 4px 0;
  padding: 8px 15px;
  font-size: 18px;
  font-weight: 300;
}
button[disabled].soresu-text-button {
  background-color: #d9d9d9;
  border: 1px solid #d9d9d9;
}
.soresu-dropdown {
  position: relative;
  min-height: 70px;
  margin-top: 0;
  padding-left: 0;
  min-width: 350px;
}
.soresu-dropdown .dropdown-list {
  display: grid;
}
.soresu-dropdown .rw-popup-container div {
  display: block;
}
.soresu-dropdown .rw-dropdownlist {
  min-width: 350px;
  background: none;
  border: none;
  padding: 0 0 4px 0;
  transition-duration: 0.2s;
}
.soresu-dropdown .rw-dropdownlist input {
  width: 330px;
}
.soresu-dropdown .rw-dropdownlist .rw-popup-container {
  z-index: 20000;
  width: 376px;
  max-height: 1000px;
  padding-top: 16px;
  top: 50px;
  border: 1px solid #d9d9d9;
  border-top: none;
  transition-duration: 0.5s;
}
.soresu-dropdown .rw-dropdownlist .rw-popup-container ul {
  height: auto;
}
.soresu-dropdown .rw-dropdownlist .rw-popup-container li {
  margin: 0 12px 0 12px;
  width: auto;
}
.soresu-dropdown .rw-dropdownlist.rw-open {
  height: auto;
  box-shadow: none;
}
.soresu-dropdown .rw-dropdownlist.rw-open div.rw-input {
  border: solid 4px #73ba21;
  padding: 10px;
}
.soresu-dropdown .rw-dropdownlist.rw-open div.rw-input span {
  position: relative;
  display: block;
  height: 14px;
}
.soresu-dropdown .rw-dropdownlist.rw-open div.rw-input span:before,
.soresu-dropdown .rw-dropdownlist.rw-open div.rw-input span:after {
  right: 0;
  top: -10px;
  position: absolute;
  display: block;
  content: "";
  border: 7px solid transparent;
}
.soresu-dropdown .rw-dropdownlist.rw-open div.rw-input span:before {
  bottom: 10px;
  border-bottom-color: #534f4e;
}
.soresu-dropdown .rw-dropdownlist.rw-open div.rw-input span:after {
  bottom: 9px;
  border-bottom-color: #fff;
  /* Match background colour */
}
.soresu-dropdown .rw-dropdownlist.rw-open input.rw-input {
  height: 26px;
  margin-left: 12px;
  margin-bottom: 2px;
}
.soresu-dropdown div.rw-input {
  min-width: 350px;
  margin: 0;
  padding: 10px;
  color: #000;
  background-color: #fff;
  border: solid 4px #73ba21;
}
.soresu-dropdown div.rw-input span {
  padding-bottom: 8px;
  position: relative;
  display: block;
  height: 14px;
}
.soresu-dropdown div.rw-input span:before,
.soresu-dropdown div.rw-input span:after {
  right: 0;
  position: absolute;
  display: block;
  content: "";
  border: 7px solid transparent;
}
.soresu-dropdown div.rw-input span:before {
  top: 10px;
  border-top-color: #534f4e;
}
.soresu-dropdown div.rw-input span:after {
  top: 9px;
  border-top-color: #fff;
  /* Match background colour */
}
.soresu-dropdown .rw-state-disabled div.rw-input {
  color: #999290;
  border: solid 4px #d9d9d9;
  background-color: #fafafa;
  cursor: default;
}
.soresu-dropdown.soresu-dropdown-unselected .rw-dropdownlist div.rw-input {
  border: solid 1px #c1c1c1;
}
.soresu-dropdown.error .rw-dropdownlist div.rw-input {
  border: solid 1px #c9302c;
}
.soresu-opener-handle {
  color: #159ecb;
  cursor: pointer;
}
.soresu-opener-handle.closed:after {
  content: " \\25BC";
  font-family: Arial, sans-serif;
}
.soresu-opener-handle.open:after {
  content: " \\25B2";
  font-family: Arial, sans-serif;
}
.soresu-accordion {
  overflow-y: hidden;
  margin-bottom: 40px;
  transition-property: max-height;
  transition-duration: 0.5s;
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  width: 800px;
}
`, "",{"version":3,"sources":["webpack://./soresu-form/web/form/style/common.less","webpack://./soresu-form/web/form/style/main.less","webpack://./soresu-form/web/form/style/tooltip.less"],"names":[],"mappings":"AAgBA;EACE,0CAAA;ACfF;AD4KA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;EACA,YAAA;EACA,0BAAA;EACA,kBAAA;EACA,UAAA;AC1KF;AD6KA;EACE,kBAAA;AC3KF;AD8KA;EACE,qBAAA;EACA,YAAA;AC5KF;AD+KA;EACE,aAAA;AC7KF;ADgLA;EACE,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,aAAA;AC9KF;ADiLA;EACE,yBAAA;AC/KF;ADkLA;EACE,aAAA;EACA,OAAA;EACA,MAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,0CAAA;AChLF;ADmLA;EACE,yBAAA;ACjLF;ADoLA;;EAEE,cAAA;EACA,iBAAA;AClLF;ACnDA;EACE,kBAAA;ADqDF;ACpDE;;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,6FAAA;ADuDJ;ACrDE;EAEE,6FAAA;ADsDJ;AClDA;EAEE,kBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;ADmDF;AD3DE;;EAEE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;AC6DJ;AD1DE;EACE,WAAA;EACA,kBAAA;AC4DJ;ADzDE;EACE,WAAA;EACA,kBAAA;AC2DJ;ACjEA;EACE,mBAAA;EACA,aAAA;EACA,WAAA;ADmEF;AD1CE;;EAEE,gBAAA;AC4CJ;ADzCE;EACE,aAAA;EACA,yBAAA;AC2CJ;ADxCE;EACE,aAAA;EACA,sBAAA;AC0CJ;ACxEA;EACE,YAAA;AD0EF;AD1EE;;EAEE,aAAA;AC4EJ;ADzEE;EACE,UAAA;EACA,4BAAA;AC2EJ;ADxEE;EACE,UAAA;EACA,yBAAA;AC0EJ;AC/EA;EACE,SAAA;ADiFF;ADvDE;;EAEE,cAAA;ACyDJ;ADtDE;EACE,QAAA;EACA,WAAA;EACA,2BAAA;ACwDJ;ADrDE;EACE,QAAA;EACA,WAAA;EACA,wBAAA;ACuDJ;ACxFA;EACE,UAAA;EACA,WAAA;AD0FF;ADtDE;;EAEE,eAAA;ACwDJ;ADrDE;EACE,WAAA;EACA,0BAAA;ACuDJ;ADpDE;EACE,QAAA;EACA,WAAA;EACA,uBAAA;ACsDJ;AChGA;EACE,UAAA;EACA,YAAA;ADkGF;ADlJE;;EAEE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;ACoJJ;ADjJE;EACE,WAAA;EACA,kBAAA;ACmJJ;ADhJE;EACE,WAAA;EACA,kBAAA;ACkJJ;AD7IE;;EAEE,aAAA;AC+IJ;AD5IE;EACE,UAAA;EACA,4BAAA;AC8IJ;AD3IE;EACE,UAAA;EACA,yBAAA;AC6IJ;ACvHA;EACE,SAAA;EACA,WAAA;ADyHF;ADnLE;;EAEE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;ACqLJ;ADlLE;EACE,WAAA;EACA,kBAAA;ACoLJ;ADjLE;EACE,WAAA;EACA,kBAAA;ACmLJ;AD9KE;;EAEE,aAAA;ACgLJ;AD7KE;EACE,UAAA;EACA,4BAAA;AC+KJ;AD5KE;EACE,UAAA;EACA,yBAAA;AC8KJ;AC9IA;EACE,SAAA;EACA,YAAA;ADgJF;ADpNE;;EAEE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;ACsNJ;ADnNE;EACE,WAAA;EACA,kBAAA;ACqNJ;ADlNE;EACE,WAAA;EACA,kBAAA;ACoNJ;AD9LE;;EAEE,gBAAA;ACgMJ;AD7LE;EACE,aAAA;EACA,yBAAA;AC+LJ;AD5LE;EACE,aAAA;EACA,sBAAA;AC8LJ;ACrKA;EACE,YAAA;EACA,WAAA;ADuKF;ACpKA;EACE,gBAAA;EACA,YAAA;EACA,WAAA;ADsKF;AD1PE;;EAEE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;AC4PJ;ADzPE;EACE,WAAA;EACA,kBAAA;AC2PJ;ADxPE;EACE,WAAA;EACA,kBAAA;AC0PJ;ADpOE;;EAEE,gBAAA;ACsOJ;ADnOE;EACE,aAAA;EACA,yBAAA;ACqOJ;ADlOE;EACE,aAAA;EACA,sBAAA;ACoOJ;AC7LA;EACE,gBAAA;EACA,YAAA;EACA,WAAA;AD+LF;AA3SA;EACE,qCAAA;AA6SF;AA9SA;;;;EAKM,qBAAA;AA+SN;AApTA;EAUI,yBAAA;AA6SJ;AAvTA;;EAaI,yBAAA;AA8SJ;AA3TA;EAgBI,yBAAA;AA8SJ;AA1SI;EACE,6FAAA;AA4SN;AAvSA;EACE,oCAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;AAySF;AAvSE;EAAA;IACE,uBAAA;IACA,YAAA;EA0SF;AACF;AAvSA;EACE,cAAA;EACA,eAAA;EACA,qBAAA;AAySF;AAtSA;EAEE,sBAAA;EACA,gBAAA;AAuSF;AA1SA;EAMI,kBAAA;AAuSJ;AA7SA;EAUI,cAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;AAsSJ;AAlSA;EACE,eAAA;EACA,iBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,sEAAA;AAoSF;AAjSA;EACE,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;AAmSF;AAxSA;EAQI,gBAAA;EACA,eAAA;EACA,SAAA;AAmSJ;AA7SA;;EAcI,cAAA;EACA,gBAAA;EACA,eAAA;AAmSJ;AAjSI;EAAA;;IACE,YAAA;EAqSJ;AACF;AAzTA;EAwBI,YAAA;AAoSJ;AA5TA;EA4BI,yBAAA;AAmSJ;AAhSE;EAAA;IACE,SAAA;EAmSF;AACF;AA/RA;EAEI,SAAA;EACA,SAAA;EACA,UAAA;AAgSJ;AApSA;;EAQI,cAAA;EACA,iBAAA;AAgSJ;AA9RI;;EACE,cAAA;AAiSN;AA7SA;;EAgBM,YAAA;AAiSN;AAjTA;EAsBI,cAAA;EACA,eAAA;AA8RJ;AArTA;EA2BI,iBAAA;AA6RJ;AAzRA;EACE,kBAAA;EACA,iBAAA;EACA,6BAAA;AA2RF;AA9RA;EAMI,WAAA;AA2RJ;AAjSA;EAUI,cAAA;AA0RJ;AApSA;EAcI,mBAAA;AAyRJ;AAvSA;;;EAiBM,qBAAA;AA2RN;AAvRE;EAAA;IACE,aAAA;EA0RF;AACF;AAtRA;;EAEE,gBAAA;AAwRF;AAtRE;;EACE,qBAAA;AAyRJ;AArRA;EAEI,cAAA;AAsRJ;AAxRA;EAMI,qBAAA;EACA,mBAAA;AAqRJ;AA5RA;EAUM,sBAAA;AAqRN;AAnRM;EACE,cAAA;AAqRR;AAlSA;EAkBM,2BAAA;EACA,uBAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;AAmRN;AA9QE;EAEI,gBAAA;AA+QN;AAhOA;;;;;;EApCI,yBAAA;EACA,YAAA;EACA,sBAAA;AA4QJ;AA1OA;;;;;;EA5BI,yBAAA;AA8QJ;AAlPA;;;;EAxBI,eAAA;EACA,yBAAA;EACA,yBAAA;AAgRJ;AA1PA;;;;;;;;EAbI,2BAAA;EACA,0BAAA;AAiRJ;AArQA;;;;;;;;EDnQE,wCAAA;EACA,qCAAA;EACA,oCAAA;EACA,mCAAA;EACA,gCAAA;EC2PE,aAAA;AAwRJ;AApRA;;;;;;ED/II,2BAAA;EACA,0BAAA;AC2aJ;AA7RA;;;;EAOI,oBAAA;EACA,eAAA;AA4RJ;AA1RI;;;;EACE,WAAA;AA+RN;AA7RI;;;;EACE,YAAA;AAkSN;AAhSI;;;;EACE,YAAA;AAqSN;AAnSI;;;;EACE,YAAA;AAwSN;AAtSI;;;;EACE,YAAA;AA2SN;AAzSI;;;;EACE,YAAA;AA8SN;AAzSI;;EACE,WAAA;AA4SN;AA1SI;;EACE,YAAA;AA6SN;AA3SI;;EACE,YAAA;AA8SN;AA5SI;;EACE,YAAA;AA+SN;AA7SI;;EACE,YAAA;AAgTN;AA9SI;;EACE,YAAA;AAiTN;AA5SA;;;EAxFI,yBAAA;EACA,YAAA;EACA,sBAAA;AAyYJ;AAnTA;;;EAhFI,yBAAA;AAwYJ;AAxTA;;EA5EI,eAAA;EACA,yBAAA;EACA,yBAAA;AAwYJ;AA9TA;;;;EAjEI,2BAAA;EACA,0BAAA;AAqYJ;AArUA;;;;EDvTE,wCAAA;EACA,qCAAA;EACA,oCAAA;EACA,mCAAA;EACA,gCAAA;EC2PE,aAAA;AAwYJ;AAhVA;;;EDnMI,2BAAA;EACA,0BAAA;ACwhBJ;AAtVA;;EA7CI,oBAAA;EACA,eAAA;AAuYJ;AArYI;;EACE,WAAA;AAwYN;AAtYI;;EACE,YAAA;AAyYN;AAvYI;;EACE,YAAA;AA0YN;AAxYI;;EACE,YAAA;AA2YN;AAzYI;;EACE,YAAA;AA4YN;AA1YI;;EACE,YAAA;AA6YN;AAxYI;EACE,WAAA;AA0YN;AAxYI;EACE,YAAA;AA0YN;AAxYI;EACE,YAAA;AA0YN;AAxYI;EACE,YAAA;AA0YN;AAxYI;EACE,YAAA;AA0YN;AAxYI;EACE,YAAA;AA0YN;AArYA;EAII,iBAAA;AAoYJ;AAhYA;;;EAhGI,yBAAA;EACA,YAAA;EACA,sBAAA;AAqeJ;AAvYA;;;EAxFI,yBAAA;AAoeJ;AA5YA;;EApFI,eAAA;EACA,yBAAA;EACA,yBAAA;AAoeJ;AAlZA;;;;EAzEI,2BAAA;EACA,0BAAA;AAieJ;AAzZA;;;;ED/TE,wCAAA;EACA,qCAAA;EACA,oCAAA;EACA,mCAAA;EACA,gCAAA;EC2PE,aAAA;AAoeJ;AApaA;;;ED3MI,2BAAA;EACA,0BAAA;AConBJ;AA1aA;;EArDI,oBAAA;EACA,eAAA;AAmeJ;AAjeI;;EACE,WAAA;AAoeN;AAleI;;EACE,YAAA;AAqeN;AAneI;;EACE,YAAA;AAseN;AApeI;;EACE,YAAA;AAueN;AAreI;;EACE,YAAA;AAweN;AAteI;;EACE,YAAA;AAyeN;AApeI;EACE,WAAA;AAseN;AApeI;EACE,YAAA;AAseN;AApeI;EACE,YAAA;AAseN;AApeI;EACE,YAAA;AAseN;AApeI;EACE,YAAA;AAseN;AApeI;EACE,YAAA;AAseN;AArdA;;;EApGI,yBAAA;EACA,YAAA;EACA,sBAAA;AA8jBJ;AA5dA;;;EA5FI,yBAAA;AA6jBJ;AAjeA;;EAxFI,eAAA;EACA,yBAAA;EACA,yBAAA;AA6jBJ;AAveA;;;;EA7EI,2BAAA;EACA,0BAAA;AA0jBJ;AA9eA;;;;EDnUE,wCAAA;EACA,qCAAA;EACA,oCAAA;EACA,mCAAA;EACA,gCAAA;EC2PE,aAAA;AA6jBJ;AAzfA;;;ED/MI,2BAAA;EACA,0BAAA;AC6sBJ;AA/fA;EAMI,gBAAA;AA4fJ;AAlgBA;EAUI,YAAA;EACA,YAAA;EACA,eAAA;AA2fJ;AAzfI;EACE,WAAA;AA2fN;AAzfI;EACE,WAAA;AA2fN;AAzfI;EACE,WAAA;AA2fN;AAzfI;EACE,YAAA;AA2fN;AAzfI;EACE,YAAA;AA2fN;AAzfI;EACE,YAAA;AA2fN;AAzhBA;EAmCI,cAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;AAyfJ;AAtfE;EAAA;IACE,WAAA;EAyfF;AACF;AAtfA;;;;EA3HI,2BAAA;EACA,0BAAA;AAunBJ;AA7fA;;;;EDjXE,wCAAA;EACA,qCAAA;EACA,oCAAA;EACA,mCAAA;EACA,gCAAA;EC2PE,aAAA;AA0nBJ;AA/fA;;;;EAEI,aAAA;AAmgBJ;AArgBA;;;;EAMI,qBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,eAAA;AAqgBJ;AAjhBA;;;;EAgBI,yBAAA;AAugBJ;AAvhBA;;EAoBI,YAAA;AAugBJ;AA3hBA;;;;EAwBI,WAAA;EACA,4EAAA;EACA,eAAA;EACA,yBAAA;AAygBJ;AApiBA;;EA+BI,cAAA;EACA,qBAAA;EACA,yBAAA;EACA,eAAA;AAygBJ;AA3iBA;;EAsCI,cAAA;EACA,yBAAA;EACA,yBAAA;AAygBJ;AAngBA;EAGE,yBAAA;EACA,oBAAA;EACA,6BAAA;AAmgBF;AAxgBA;EAQI,cAAA;AAmgBJ;AA3gBA;EAYI,mBAAA;EACA,cAAA;AAkgBJ;AA/fE;EACE,yBAAA;EACA,iBAAA;AAigBJ;AA9fE;EACE,yBAAA;AAggBJ;AA7fE;;;;;EAMI,cAAA;AA8fN;AApgBE;EAUI,yBAAA;EACA,qBAAA;AA6fN;AAzfE;EACE,cAAA;EACA,gBAAA;AA2fJ;AAxfE;EACE,cAAA;EACA,gBAAA;AA0fJ;AAzfI;EACE,iBAAA;AA2fN;AAzfI;EACE,iBAAA;AA2fN;AAvfE;EACE,cAAA;EACA,iBAAA;AAyfJ;AAxfI;EACE,iBAAA;AA0fN;AArfI;EACE,iBAAA;AAufN;AAxfI;EAGI,iBAAA;AAwfR;AArfI;EACE,qBAAA;AAufN;AArfI;EACE,iBAAA;EACA,gCAAA;AAufN;AAnfE;EACE,gBAAA;EACA,gBAAA;EACA,yBAAA;AAqfJ;AApfI;EACE,yBAAA;AAsfN;AAlfE;EACE,cAAA;EACA,iBAAA;AAofJ;AAnfI;EACE,gCAAA;EACA,iBAAA;AAqfN;AAnfI;EACE,gCAAA;AAqfN;AAjfE;EACE,WAAA;EACA,kBAAA;AAmfJ;AAhfE;EACE,kBAAA;EACA,YAAA;EACA,QAAA;AAkfJ;AA9eA;EAEI,kBAAA;EACA,QAAA;EACA,SAAA;AA+eJ;AAnfA;EAQI,qBAAA;EACA,SAAA;AA8eJ;AA1eA;EACE,gBAAA;EACA,kBAAA;AA4eF;AA1eE;EAEI,cAAA;AA2eN;AAjfA;EAUI,WAAA;EACA,yBAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;AA0eJ;AAveE;EACE,cAAA;AAyeJ;AA1eE;EAGI,yBAAA;EACA,yBAAA;EACA,eAAA;AA0eN;AA/eE;EAQI,qBAAA;EACA,eAAA;AA0eN;AAreA;EACE,kFAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AAueF;AAreA;EACE,kFAAA;AAueF;AApeA;;EACE,WAAA;EACA,yBAAA;EACA,eAAA;EACA,sBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;AAueF;AApeA;EACE,yBAAA;EACA,yBAAA;AAseF;AAleA;EACE,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;AAoeF;AAzeA;EAQI,aAAA;AAoeJ;AA5eA;EAWI,cAAA;AAoeJ;AA/eA;EAeI,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AAmeJ;AAtfA;EAqBM,YAAA;AAoeN;AAzfA;EAyBM,cAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,SAAA;EACA,yBAAA;EACA,gBAAA;EACA,yBAAA;AAmeN;AAngBA;EAmCQ,YAAA;AAmeR;AAtgBA;EAsCQ,qBAAA;EACA,WAAA;AAmeR;AA/dI;EACE,YAAA;EACA,gBAAA;AAieN;AAneI;EAII,yBAAA;EACA,aAAA;AAkeR;AAveI;EDjhBF,kBAAA;EACA,cAAA;EACA,YAAA;AC2/BF;ADz/BE;;EAEE,QAAA;EACA,UAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,6BAAA;AC2/BJ;ADx/BE;EACE,YAAA;EACA,4BAAA;AC0/BJ;ADv/BE;EACE,WAAA;EACA,yBAAA;ECy/BF,4BAA4B;AAC9B;AA9fI;EAWI,YAAA;EACA,iBAAA;EACA,kBAAA;AAsfR;AA9iBA;EA8DI,gBAAA;EACA,SAAA;EACA,aAAA;EACA,WAAA;EACA,sBAAA;EACA,yBAAA;AAmfJ;AAtjBA;EAqEM,mBAAA;EDjhBJ,kBAAA;EACA,cAAA;EACA,YAAA;ACsgCF;ADpgCE;;EAEE,QAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,6BAAA;ACsgCJ;ADngCE;EACE,SAAA;EACA,yBAAA;ACqgCJ;ADlgCE;EACE,QAAA;EACA,sBAAA;ECogCF,4BAA4B;AAC9B;AA7kBA;EA2EI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,eAAA;AAqgBJ;AAlgBA;EACE,yBAAA;AAogBF;AAlgBA;EACE,yBAAA;AAogBF;AAjgBA;EACE,cAAA;EACA,eAAA;AAmgBF;AAjgBE;EACE,iBAAA;EACA,8BAAA;AAmgBJ;AAhgBE;EACE,iBAAA;EACA,8BAAA;AAkgBJ;AA9fA;EACE,kBAAA;EACA,mBAAA;EACA,+BAAA;EACA,yBAAA;EACA,sDAAA;EACA,YAAA;AAggBF","sourcesContent":[".ease-in-out(@seconds) {\n  -webkit-transition: all @seconds ease-in-out;\n  -moz-transition: all @seconds ease-in-out;\n  -ms-transition: all @seconds ease-in-out;\n  -o-transition: all @seconds ease-in-out;\n  transition: all @seconds ease-in-out;\n}\n\n.scale(@factor) {\n  -webkit-transform: scale(@factor);\n  -moz-transform: scale(@factor);\n  -ms-transform: scale(@factor);\n  -o-transform: scale(@factor);\n  transform: scale(@factor);\n}\n\n.popup-box-shadow {\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.4);\n}\n\n.box-triangle(@position) {\n  &:before,\n  &:after {\n    content: \"\";\n    position: absolute;\n    width: 0;\n    height: 0;\n    border-style: solid;\n    border-color: transparent;\n  }\n\n  &:before {\n    left: @position;\n    border-width: 11px;\n  }\n\n  &:after {\n    left: @position + 1px;\n    border-width: 10px;\n  }\n}\n\n.box-triangle-up(@stroke, @fill) {\n  &:before,\n  &:after {\n    border-top: 0;\n  }\n\n  &:before {\n    top: -11px;\n    border-bottom-color: @stroke;\n  }\n\n  &:after {\n    top: -10px;\n    border-bottom-color: @fill;\n  }\n}\n\n.box-triangle-down(@stroke, @fill) {\n  &:before,\n  &:after {\n    border-bottom: 0;\n  }\n\n  &:before {\n    bottom: -11px;\n    border-top-color: @stroke;\n  }\n\n  &:after {\n    bottom: -10px;\n    border-top-color: @fill;\n  }\n}\n\n.box-triangle-left(@stroke, @fill) {\n  &:before,\n  &:after {\n    border-left: 0;\n  }\n\n  &:before {\n    top: 8px;\n    left: -11px;\n    border-right-color: @stroke;\n  }\n\n  &:after {\n    top: 9px;\n    left: -10px;\n    border-right-color: @fill;\n  }\n}\n\n.box-triangle-right(@stroke, @fill) {\n  &:before,\n  &:after {\n    border-right: 0;\n  }\n\n  &:before {\n    left: 630px;\n    border-left-color: @stroke;\n  }\n\n  &:after {\n    top: 6px;\n    left: 630px;\n    border-left-color: @fill;\n  }\n}\n\n.soresu-focus-show-error() {\n  input:focus.error,\n  select:focus.error,\n  textarea:focus.error {\n    box-shadow: 0 0 5px rgba(97, 186, 233, 1);\n    outline: 1px solid @bright-red;\n  }\n}\n\n@soresu-chevron-offset: 10px;\n.soresu-chevron-up(@size, @thickness, @color) {\n  position: relative;\n  display: block;\n  height: @size;\n\n  &:before,\n  &:after {\n    right: 0;\n    top: -1 * @soresu-chevron-offset;\n    position: absolute;\n    display: block;\n    content: \"\";\n    border: (@size / 2) solid transparent;\n  }\n\n  &:before {\n    bottom: @soresu-chevron-offset;\n    border-bottom-color: @color;\n  }\n\n  &:after {\n    bottom: @soresu-chevron-offset - @thickness;\n    border-bottom-color: #fff; /* Match background colour */\n  }\n}\n\n.soresu-chevron-down(@size, @thickness, @color) {\n  position: relative;\n  display: block;\n  height: @size;\n\n  &:before,\n  &:after {\n    right: 0;\n    position: absolute;\n    display: block;\n    content: \"\";\n    border: (@size / 2) solid transparent;\n  }\n\n  &:before {\n    top: @soresu-chevron-offset;\n    border-top-color: @color;\n  }\n\n  &:after {\n    top: @soresu-chevron-offset - @thickness;\n    border-top-color: #fff; /* Match background colour */\n  }\n}\n\n.modal {\n  position: fixed;\n  top: 30%;\n  left: 30%;\n  right: 40%;\n  bottom: 30%;\n  background-color: @lighter-gray;\n  height: 350px;\n  width: 600px;\n  padding: 30px 5px 15px 0px;\n  border-radius: 8px;\n  opacity: 1;\n}\n\n.modal-label {\n  padding-right: 0px;\n}\n\n.modal-label > input {\n  margin: 0 10px 0 10px;\n  padding: 8px;\n}\n\n.modal:focus {\n  outline: none;\n}\n\n.modal > div {\n  text-align: center;\n  vertical-align: middle;\n  margin-top: 60px;\n  opacity: none;\n}\n\n.get-business-id:disabled {\n  background-color: @darker-gray;\n}\n\n.overlay {\n  z-index: 1000;\n  left: 0;\n  top: 0;\n  position: fixed;\n  height: 100%;\n  width: 100%;\n  background-color: rgba(255, 255, 255, 0.5);\n}\n\ninput[type=\"text\"].error {\n  border: 2px solid @bright-red;\n}\n\n#not-found-business-id,\n#other-error-business-ids > span {\n  color: @bright-red;\n  font-weight: bold;\n}\n","@import \"variables.less\";\n@import \"common.less\";\n@import \"tooltip.less\";\n\n@formHeadingWidth: 250px;\n\n.jotpa-customizations {\n  font-family: 'Montserrat', sans-serif;\n\n  .soresu-radio, .soresu-checkbox {\n    input[type=radio]:checked + label, input[type=checkbox]:checked + label {\n      border-color: @jotpa-green;\n    }\n  }\n\n  #topbar #submit:not([disabled]) {\n    background-color: @jotpa-green;\n  }\n  button.soresu-text-button, input.soresu-text-button {\n    background-color: @jotpa-green;\n  }\n  .soresu-file-upload .soresu-upload-button {\n    background-color: @jotpa-green;\n  }\n\n  .soresu-tooltip {\n    &.soresu-help-icon {\n      background: transparent url(\"../img/show_jotpa_tooltip.png\") no-repeat left top !important;\n    }\n  }\n}\n\nbody {\n  font-family: 'Open Sans', sans-serif;\n  background-color: @lightest-gray;\n  color: @text-black;\n  font-size: 16px;\n\n  @media print {\n    background-color: white;\n    color: black;\n  }\n}\n\na {\n  color: @light-blue;\n  cursor: pointer;\n  text-decoration: none;\n}\n\nul {\n  // VA-specific style?\n  margin: 10px 0 0 -40px;\n  list-style: none;\n\n  li {\n    display: table-row;\n  }\n\n  li:before {\n    color: @light-green;\n    content:\"•\";\n    font-size: 14px;\n    padding-right: 10px;\n    display: table-cell;\n  }\n}\n\n.popup {\n  position: fixed;\n  max-height: 250px;\n  z-index: 101;\n  overflow: auto;\n  margin-right: 20px;\n  background-color: rgba(255,255,255,1);\n  padding: 10px;\n  box-shadow: 0 0 4px rgba(0,0,0,.14),0 4px 8px rgba(0,0,0,.28);\n}\n\n#container {\n  max-width: @form-width;\n  margin-top: 200px;\n  margin-left: auto;\n  margin-right: auto;\n  padding: 0 20px 20px 20px;\n\n  h1 {\n    font-weight: 300;\n    font-size: 24px;\n    margin: 0;\n  }\n\n  h2, h3 {\n    color: @darker-gray;\n    font-weight: 300;\n    font-size: 18px;\n\n    @media print {\n      color: black;\n    }\n  }\n\n  h2 > {\n    width: @formHeadingWidth;\n  }\n\n  h2 > span {\n    text-transform: uppercase;\n  }\n\n  @media print {\n    margin: 0;\n  }\n}\n\n// SORESU FORM STYLES\n.soresu-form {\n  fieldset {\n    border: 0;\n    margin: 0;\n    padding: 0;\n  }\n\n  label, legend {\n    color: @form-label-black;\n    margin: 0 0 8px 0;\n\n    &.disabled {\n      color: @darker-gray;\n    }\n\n    :after {\n      content: \" \";\n    }\n\n  }\n\n  p.soresu-info-element {\n    color: @form-label-black;\n    font-size: 15px;\n  }\n\n  .required:after {\n    content: \"\\00a0*\";\n  }\n}\n\nsection.soresu-theme {\n  margin: 25px 0 0 0;\n  padding-top: 25px;\n  border-top: 1px solid @light-gray;\n\n  h2 {\n    float: left;\n  }\n\n  label {\n    display: block;\n  }\n\n  >div {\n    margin: 0 0 0 @formHeadingWidth;\n\n    >div, >fieldset, >p.soresu-info-element {\n      margin: 15px 0 20px 0;\n    }\n  }\n\n  @media print {\n    border-top: 0;\n  }\n}\n\n// FIELDSETS / WRAPPERS\n.soresu-fieldset,\n.soresu-growing-fieldset {\n  max-width: @section-width + 11px;\n\n  & > div {\n    display: inline-block;\n  }\n}\n\n.soresu-growing-fieldset {\n  div.extra-large {\n    display: block;\n  }\n\n  ol {\n    list-style-type: none;\n    counter-reset: item;\n\n    li.soresu-growing-fieldset-child {\n      margin: 20px 0 0 -58px;\n\n      &.disabled {\n        color: @darker-gray;\n      }\n    }\n\n    li:before {\n      content: counter(item) \"  \";\n      counter-increment: item;\n      float: left;\n      width: 1em;\n      font-size: 18px;\n      margin-top: 15px;\n    }\n\n  }\n\n  &.show-only-first-label ol {\n    li:first-child:before {\n      margin-top: 45px;\n    }\n  }\n}\n// END FIELDSETS / WRAPPERS\n\n// FORM COMPONENTS\n.soresu-text-component() {\n  input[type=text],\n  input[type=email],\n  textarea {\n    border: 1px solid @middle-gray;\n    padding: 8px;\n    background-color: #fff;\n  }\n\n  input[type=text].error,\n  input[type=email].error,\n  textarea.error {\n    border: 1px solid @bright-red;\n  }\n\n  textarea[disabled], input[disabled] {\n    cursor: default;\n    background-color: @lightest-gray;\n    border: 1px solid @light-gray;\n  }\n}\n\n.soresu-focus-animation() {\n  input:focus,\n  select:focus,\n  textarea:focus,\n  button:focus {\n    box-shadow: 0 0 5px rgba(97, 186, 233, 1);\n    outline: 1px solid @light-blue;\n  }\n\n  input,\n  select,\n  textarea,\n  button {\n    .ease-in-out(0.30s);\n    outline: none;\n  }\n}\n\n.soresu-text-field,\n.soresu-email-field {\n  .soresu-text-component();\n  .soresu-focus-animation();\n  .soresu-focus-show-error();\n\n  input[type=text], input[type=email] {\n    margin: 5px 10px 0 0;\n    font-size: 18px;\n\n    &.extra-extra-small {\n      width: ceil((@section-width / 8))  - 18px;\n    }\n    &.extra-small {\n      width: ceil((@section-width / 4))  - 18px;\n    }\n    &.small {\n      width: ceil((@section-width / 3)) - 18px;\n    }\n    &.medium {\n      width: ceil((@section-width / 2)) - 18px;\n    }\n    &.large {\n      width: ceil((@section-width / 1.5)) - 28px;\n    }\n    &.extra-large {\n      width: @section-width - 18px;\n    }\n  }\n\n  label {\n    &.extra-extra-small {\n      width: ceil((@section-width / 8))  - 8px;\n    }\n    &.extra-small {\n      width: ceil((@section-width / 4))  - 8px;\n    }\n    &.small {\n      width: ceil((@section-width / 3)) - 8px;\n    }\n    &.medium {\n      width: ceil((@section-width / 2)) - 8px;\n    }\n    &.large {\n      width: ceil((@section-width / 1.5)) - 18px;\n    }\n    &.extra-large {\n      width: @section-width - 8px;\n    }\n  }\n}\n\n.soresu-money-field {\n  .soresu-text-field();\n\n  input {\n    text-align: right;\n  }\n}\n\n.soresu-finnish-business-id-field {\n  .soresu-text-field();\n}\n\n.soresu-text-area {\n  .soresu-text-component();\n  .soresu-focus-animation();\n  .soresu-focus-show-error();\n\n  label {\n    max-width: @section-width;\n  }\n\n  textarea {\n    width: @section-width - 18px;\n    height: 12em;\n    font-size: 16px;\n\n    &.extra-extra-small {\n      height: 1em;\n    }\n    &.extra-small {\n      height: 3em;\n    }\n    &.small {\n      height: 6em;\n    }\n    &.medium {\n      height: 12em;\n    }\n    &.large {\n      height: 18em;\n    }\n    &.extra-large {\n      height: 24em;\n    }\n  }\n\n  .length-left {\n    color: @dark-gray;\n    font-size: 12px;\n    width: @section-width - 10px;\n    text-align: right;\n  }\n\n  @media print {\n    width: 100%;\n  }\n}\n\n.soresu-text-button {\n  .soresu-focus-animation();\n}\n\n.soresu-dropdown() {\n  .soresu-focus-animation();\n  .soresu-focus-show-error();\n}\n\n.soresu-radio, .soresu-checkbox {\n  input[type=radio], input[type=checkbox] {\n    display: none;\n  }\n\n  input[type=radio] + label, input[type=checkbox] + label  {\n    display: inline-block;\n    color: @dark-gray;\n    margin: 4px 3px;\n    padding: 12px 30px;\n    background-color: #fff;\n    border: solid 1px @middle-gray;\n    cursor: pointer;\n  }\n\n  input[type=radio] + label.error, input[type=checkbox] + label.error {\n    border: solid 1px @bright-red;\n  }\n\n  input[type=checkbox] + label  {\n    width: @section-width - 68px;\n  }\n\n  input[type=radio]:checked + label, input[type=checkbox]:checked + label {\n    color: #000;\n    background: #fff url('../img/checkmark.png') no-repeat 10px 19px;\n    margin: 1px 1px;\n    border: solid 4px @light-green;\n  }\n\n  input[disabled] + label {\n    color: @light-gray;\n    border-color: @light-gray;\n    background-color: @lightest-gray;\n    cursor: default;\n  }\n\n  input[disabled]:checked + label {\n    color: @dark-gray;\n    border: solid 4px @light-gray;\n    background-color: @lightest-gray;\n  }\n}\n\n\n\n.soresu-table {\n  @content-padding: 4px 10px;\n\n  border-collapse: separate;\n  border-spacing: 20px;\n  border: 1px solid transparent;\n\n  div {\n    display: block;  // override leaking `.soresu-fieldset div` rule\n  }\n\n  th.required::after {\n    font-weight: normal;\n    font-size: 80%;\n  }\n\n  &--preview {\n    border-collapse: collapse;\n    border-spacing: 0;\n  }\n\n  &--error {\n    border: 1px solid @bright-red;\n  }\n\n  &--disabled {\n    .soresu-table__caption,\n    .soresu-table__column-title-cell,\n    .soresu-table__row-title-cell,\n    .soresu-table__value-cell,\n    .soresu-table__sum-cell {\n      color: @darker-gray;\n    }\n\n    .soresu-table__value-cell-input {\n      background-color: @lightest-gray;\n      border-color: @light-gray;\n    }\n  }\n\n  &__caption {\n    color: @form-label-black;\n    text-align: left;\n  }\n\n  &__column-title-cell {\n    color: @form-label-black;\n    text-align: left;\n    &--number {\n      text-align: right;\n    }\n    &--preview {\n      padding: @content-padding;\n    }\n  }\n\n  &__row-title-cell {\n    color: @form-label-black;\n    text-align: right;\n    &--preview {\n      padding: @content-padding;\n    }\n  }\n\n  &__value-cell {\n    &--number {\n      text-align: right;\n      .soresu-table__value-cell-input {\n        text-align: right;\n      }\n    }\n    &--placeholder .soresu-table__value-cell-input {\n      border-color: @lightish-gray;\n    }\n    &--preview {\n      padding: @content-padding;\n      border-bottom: 1px solid @middle-gray;\n    }\n  }\n\n  &__value-cell-input {\n    text-align: left;\n    padding: 5px 9px;\n    border: 1px solid @middle-gray;\n    &--error {\n      border: 1px solid @bright-red;\n    }\n  }\n\n  &__sum-cell {\n    color: @form-label-black;\n    padding: @content-padding;\n    &--number {\n      border-bottom: 1px solid @middle-gray;\n      text-align: right;\n    }\n    &--preview {\n      border-bottom: 1px solid @middle-gray;\n    }\n  }\n\n  &__cell-positioner {\n    width: 100%;\n    position: relative;\n  }\n\n  &__remove-row-button {\n    position: absolute;\n    right: -30px;\n    top: 8px;\n  }\n}\n\ndiv.soresu-attachment-input-field {\n  button.soresu-remove {\n    position: relative;\n    top: 4px;\n    left: 6px;\n  }\n\n  div.soresu-attachment-display {\n    display: inline-block;\n    margin: 0;\n  }\n}\n\n.soresu-file-upload {\n  margin-top: 10px;\n  margin-bottom: 4px;\n\n  &.error {\n    span.required {\n      color: @bright-red;\n    }\n  }\n  .soresu-upload-button {\n    color: #fff;\n    background-color: @light-green;\n    border-width: 0;\n    margin: 4px 0 4px 0;\n    padding: 4px 24px;\n    font-size: 16px;\n    cursor: pointer;\n  }\n\n  &.disabled {\n    color: @darker-gray;\n    .soresu-upload-button {\n      background-color: @light-gray;\n      border: 1px solid @light-gray;\n      cursor: default;\n    }\n    div {\n      border-color: @dark-gray;\n      cursor: default;\n    }\n  }\n}\n\nbutton.soresu-remove {\n  background: transparent url('../img/remove_line_enabled.png') no-repeat left top;\n  border-width: 0;\n  width: 20px;\n  height: 22px;\n}\nbutton[disabled].soresu-remove {\n  background: transparent url('../img/remove_line_disabled.png') no-repeat left top;\n}\n\nbutton.soresu-text-button, input.soresu-text-button {\n  color: #fff;\n  background-color: @light-green;\n  border-width: 0;\n  margin: 4px 20px 4px 0;\n  padding: 8px 15px;\n  font-size: 18px;\n  font-weight: 300;\n}\n\nbutton[disabled].soresu-text-button {\n  background-color: @light-gray;\n  border: 1px solid @light-gray;\n}\n\n@soresu-dropdown-width: 350px;\n.soresu-dropdown {\n  position: relative;\n  min-height: 70px;\n  margin-top: 0;\n  padding-left: 0;\n  min-width: @soresu-dropdown-width;\n\n  .dropdown-list {\n    display: grid;\n  }\n  .rw-popup-container div {\n    display: block;\n  }\n\n  .rw-dropdownlist {\n    min-width: @soresu-dropdown-width;\n    background: none;\n    border: none;\n    padding: 0 0 4px 0;\n    transition-duration: 0.2s;\n    input {\n      width: @soresu-dropdown-width - 20px;\n    }\n\n    .rw-popup-container {\n      z-index: 20000;\n      width: @soresu-dropdown-width + 26px;\n      max-height: 1000px;\n      padding-top: 16px;\n      top: 50px;\n      border: 1px solid @light-gray;\n      border-top: none;\n      transition-duration: 0.5s;\n\n      ul {\n        height: auto;\n      }\n      li {\n        margin: 0 12px 0 12px;\n        width: auto;\n      }\n    }\n\n    &.rw-open {\n      height: auto;\n      box-shadow: none;\n      div.rw-input {\n        border: solid 4px @light-green;\n        padding: 10px;\n        span {\n          .soresu-chevron-up(14px, 1px, @mid-gray);\n        }\n      }\n      input.rw-input {\n        height: 26px;\n        margin-left: 12px;\n        margin-bottom: 2px;\n      }\n    }\n  }\n\n  div.rw-input {\n    min-width: @soresu-dropdown-width;\n    margin: 0;\n    padding: 10px;\n    color: #000;\n    background-color: #fff;\n    border: solid 4px @light-green;\n    span {\n      padding-bottom: 8px;\n      .soresu-chevron-down(14px, 1px, @mid-gray);\n    }\n  }\n\n  .rw-state-disabled div.rw-input {\n    color: @dark-gray;\n    border: solid 4px @light-gray;\n    background-color: @lightest-gray;\n    cursor: default;\n  }\n}\n.soresu-dropdown.soresu-dropdown-unselected .rw-dropdownlist div.rw-input {\n  border: solid 1px @middle-gray;\n}\n.soresu-dropdown.error .rw-dropdownlist div.rw-input {\n  border: solid 1px @bright-red;\n}\n\n.soresu-opener-handle {\n  color: @light-blue;\n  cursor: pointer;\n\n  &.closed:after {\n    content: \" \\25BC\";\n    font-family: Arial, sans-serif;\n  }\n\n  &.open:after {\n    content: \" \\25B2\";\n    font-family: Arial, sans-serif;\n  }\n}\n\n.soresu-accordion {\n  overflow-y: hidden;\n  margin-bottom: 40px;\n  transition-property: max-height;\n  transition-duration: 0.5s;\n  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);\n  width: @section-width;\n}\n",".soresu-tooltip {\n  position: relative;\n  &.soresu-help-icon {\n    display: inline-block;\n    width: 16px;\n    height: 16px;\n    margin-top: 1px;\n    margin-left: 11px;\n    background: transparent url(\"../img/show_tooltip.png\") no-repeat left top !important;\n  }\n  &.jotpa-help-icon {\n    &:extend(.soresu-tooltip.soresu-help-icon);\n    background: transparent url(\"../img/show_jotpa_tooltip.png\") no-repeat left top !important;\n  }\n}\n\n.soresu-tooltip > span {\n  .box-triangle(295px);\n  position: absolute;\n  width: 600px;\n  left: -223px;\n  margin-left: -76px;\n  margin-bottom: -4px;\n  color: @form-label-black;\n  background: #fff;\n  border: 1px solid @light-gray;\n  font-size: 14px;\n  padding: 5px 15px;\n  visibility: hidden;\n  white-space: pre-line;\n}\n\n:hover.soresu-tooltip > span {\n  visibility: visible;\n  opacity: 0.95;\n  z-index: 99;\n}\n\n.soresu-tooltip-up > span {\n  .box-triangle-down(@light-gray, #fff);\n}\n\n:hover.soresu-tooltip-up > span {\n  bottom: 32px;\n}\n\n.soresu-tooltip-down > span {\n  .box-triangle-up(@light-gray, #fff);\n}\n\n:hover.soresu-tooltip-down > span {\n  top: 42px;\n}\n\n.soresu-tooltip-left > span {\n  .box-triangle-left(@light-gray, #fff);\n}\n\n:hover.soresu-tooltip-left > span {\n  top: -10px;\n  left: 106px;\n}\n\n.soresu-tooltip-right > span {\n  .box-triangle-right(@light-gray, #fff);\n}\n\n:hover.soresu-tooltip-right > span {\n  top: -10px;\n  left: -568px;\n}\n\n.soresu-tooltip-valmistelijan-huomiot > span {\n  .box-triangle(105px);\n  .box-triangle-up(@light-gray, #fff);\n}\n\n:hover.soresu-tooltip-valmistelijan-huomiot > span {\n  top: 42px;\n  left: -30px;\n}\n\n.soresu-tooltip-salli-nakyvyys > span {\n  .box-triangle(250px);\n  .box-triangle-up(@light-gray, #fff);\n}\n\n:hover.soresu-tooltip-salli-nakyvyys > span {\n  top: 42px;\n  left: -180px;\n}\n\n.soresu-tooltip-arviointi > span {\n  .box-triangle(105px);\n  .box-triangle-down(@light-gray, #fff);\n}\n\n:hover.soresu-tooltip-arviointi > span {\n  bottom: 32px;\n  left: -30px;\n}\n\n.soresu-tooltip-arviointi-slim > span {\n  max-width: 500px;\n  bottom: 32px;\n  left: -30px;\n\n  .box-triangle(105px);\n  .box-triangle-down(@light-gray, #fff);\n}\n\n:hover.soresu-tooltip-arviointi-slim > span {\n  max-width: 500px;\n  bottom: 32px;\n  left: -30px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
